export default __webpack_public_path__ + "static/media/QUICE.c4d2dd65.png";